<template>
  <div class="box">
    <div class="box-row"  >
      <div v-if="!this.rootNode && !this.templateNode" class="border">请先进行初始化</div>
      <div ref="imageDom" >
        <div :id="containerId" ref="graph_container" class="graph_container"></div>
      </div>
      <div class="control">
        <el-icon @click="zoomIn">
          <ElIconCirclePlusFilled/>
        </el-icon>
        <el-icon @click="zoomOut">
          <ElIconRemoveFilled/>
        </el-icon>
      </div>

    </div>
    <div class="form_title">
      <div v-if="this.rootNode">{{ this.currentNodeName }}</div>

      <div v-if="this.rootNode" style="position: absolute; right: 15px;margin-top: -2px">
        <frame-button
            :button="addButton"
            :parent-data="{id:this.currentNodeId,name:this.currentNodeName,company_id:this.parentData.company_id}"
        ></frame-button>

        <frame-button
            :button="editButton"
            :parent-data="{id:this.currentNodeId,name:this.currentNodeName,company_id:this.parentData.company_id}"
        ></frame-button>

        <frame-button
            :button="addContactButton"
            :parent-data="{department_id:this.currentNodeId,name:this.currentNodeName,company_id:this.parentData.company_id}"
        ></frame-button>

        <frame-button
            :button="importButton"
            :parent-data="{company_id:this.parentData.company_id}"
        ></frame-button>
        <frame-button
            :button="exportButton"
            :parent-data="{company_id:this.parentData.company_id}"
        ></frame-button>
        <el-button  v-if="hiddenEmployee"  @click="changeShow">隐藏表格</el-button>
        <el-button  v-if="showEmployee"  @click="changeShow">显示表格</el-button>
        <el-button  @click="generateImg()">导出组织结构图</el-button>
      </div>

      <div v-if="!this.rootNode" style="position: absolute; right: 10px;margin-top: -2px;">
        <div style="display: flex; margin-top: 5px">
        <el-select style="width: 100px" v-model="template_id" placeholder="公司类型" clearable>
          <el-option v-for="item in templateIdList" :key="item.template_id" :label="item.label"
                     :value="item.template_id"
                     @click="loadTemplateData(template_id)"></el-option>
        </el-select>
        <el-button style="margin-left: 10px" @click="createRoot()">初始化</el-button>
        </div>
      </div>
    </div>

    <div  class="box-row"  v-if="hiddenEmployee">
      <frame-query
          ref="frameQuery"
          componentParam="sales_chance_tab_contact_org"
          :parent-data="{company_id:this.parentData.company_id,department_id:this.currentNodeId}">
      </frame-query>

    </div>


  </div>
</template>

<script>


import {mxConstants, mxEdgeStyle, mxEvent, mxGraph} from 'mxgraph-js'
import html2canvas from "html2canvas"
export default {
  name: "CompanyOrganization",
  inject: ['$fn'],
  props: {
    componentParam: {
      type: String,
      required: true
    },
    parentData: {
      type: Object,
      default() {
        return {}
      }
    },
  },
  data() {
    return {
      templateIdList: [
        {
          template_id: "MAKE",
          label: "典型制造业"
        },
        {
          template_id: "SALES",
          label: "典型销售企业"
        },
        {
          template_id: "STUDY",
          label: "研究开发企业"
        }
      ],
      template_id: '',

      addButton: {
        "component": "button",
        "label": "添加部门",
        "click": "jsOpenDialog",
        "window": {
          "component": "frame/FrameForm",
          "type": "company_organization_node_add",
          "title": "添加部门",
          "width": 600,
          "height": 600
        }
      },
      editButton: {
        "component": "button",
        "label": "编辑部门",
        "click": "jsOpenDialog",
        "window": {
          "component": "frame/FrameForm",
          "type": "company_organization_node_edit",
          "title": "编辑部门",
          "width": 600,
          "height": 600
        }
      },
      addContactButton: {
        "component": "button",
        "label": "添加职员",
        "click": "jsOpenDialog",
        "window": {
          "component": "frame/FrameForm",
          "type": "sales_chance_tab_contact_add",
          "title": "添加职员",
          "width": 600,
          "height": 600
        }
      },
      importButton: {
        "component": "button",
        "label": "导入职员",
        "click": "jsOpenDialog",
        "window": {
          "component": "frame/FrameForm",
          "type": "sales_chance_tab_contact_import",
          "title": "导入职员",
          "width": 600,
          "height": 600
        }
      },
      exportButton: {
        "id": "导出职员",
        "component": "button",
        "label": "导出职员",
        "click": "export",
        "click_success": [
          "jsExportSuccess"
        ],
        "query_id": "sales_chance_tab_contact_org",
      },

      showEmployee: false,
      hiddenEmployee: true,

      currentNodeId: '',
      currentNodeName: '',
      graph: {},
      containerId: new Date().getTime(),
      user_id: '',
      cntList: [],
      department_id: '',
      node_id: '',

      templateNode: null,
      rootNode: null,
      nodeList: [],
      lineList: [],
      config: {
        cellHeight: 60,//矩形高度
        cellWidth: 120,//矩形长度
        cellWidthRoot: 300, //根矩形长度
        cellGap: 15,//两个矩形的间隙
        levelHeight: 100,// 每个层级的高度
      },
      leafCnt: 1
    }
  },
  provide() {
    return {
      $fn: {
        reloadTreeData: () => {
          this.destroy();
        },
      }
    }
  },
  mounted() {
    this.init();
  },
  methods: {

    //导出组织结构图图片
    generateImg(){
      window.pageYoffset = 0;
      window.pageXOffset = 0;
      document.documentElement.scrollTop = 0;
      document.documentElement.scrollLeft = 0;
      document.body.scrollTop = 0;
      document.body.scrollLeft = 0;
      html2canvas(this.$refs.imageDom,{
        scale: 1,
        useCORS: true,
        height: this.$refs.imageDom.scrollHeight,
        windowHeight: this.$refs.imageDom.scrollHeight,
        width: this.$refs.imageDom.scrollWidth,
        windowWidth: this.$refs.imageDom.scrollWidth,
      }).then(canvas => {
        //将对应dom组件转成图片并生成图片地址
        let imgUrl = canvas.toDataURL()
        // 动态生成下载图片链接
        let a = document.createElement("a")
        a.href = imgUrl
        // 利用浏览器下载器下载图片
        a.setAttribute("download","组织结构图.png")
        a.click();
      })
    },

    //隐藏职员表单
    changeShow() {
      if (this.showEmployee == true) {
        this.showEmployee = false
      } else {
        this.showEmployee = true
      }
      if (this.hiddenEmployee == false) {
        this.hiddenEmployee = true
      } else {
        this.hiddenEmployee = false
      }
    },
    //清除画布重新创建
    destroy() {
      // this.clearImage();
      this.graph.destroy();
      this.init();
    },
    //刷新表单数据
    searchByScene() {
      this.$refs.frameQuery.search();
    },

    //获取模板数据
    async loadTemplateData(template_id) {
      this.clearImage();
      let params = {template_id: template_id}
      let templateTreeData = await this.$http('companyOrganizationService.getTemplateTree', params);
      console.log("templateTreeData-=", templateTreeData);
      if (!templateTreeData) {
        this.$message.error('获取模板失败')
        return;
      }

      let deptArr = templateTreeData || [];
      this.templateNode = deptArr[0]
      if (!this.templateNode) {
        return
      }
      this.lineList = []
      this.nodeList = []
      this.process(this.templateNode);
      this.drawImage();

    },

    //初始化按钮选择模板自动创建模板节点
    async createRoot() {
      console.log("=========");
      console.log("template_id-=", this.template_id)
      if (!this.template_id) {
        this.$message.error('初始化失败,请先选择公司类型！！！')
        return
      }
      let params = {template_id: this.template_id, company_id: this.parentData.company_id, company_name: this.parentData.company_name}
      let rootData = await this.$http('companyOrganizationService.createRoot', params);
      console.log("rootData-=", rootData);
      this.node_id = rootData;
      if (rootData) {
        this.$message.success('初始化成功')
      }
      this.destroy()
    },

    //准备节点数据
    async init() {
      await this.loadDeptData()
      if (!this.rootNode) {
        return
      }
      this.lineList = []
      this.nodeList = []
      this.process(this.rootNode);
      await this.getNodeBadgeCnt();
      if (this.rootNode) {
        this.currentNodeId = this.rootNode.id;
        this.currentNodeName = this.rootNode.name
      }
      this.drawImage();
    },

    //获取节点数据
    async loadDeptData() {
      console.log("loadDeptData-=")
      let params = {company_id: this.parentData.company_id}
      let treeData = await this.$http('companyOrganizationService.getRootTree', params);
      if (!treeData) {
        this.$message.error('获取部门失败')
        return;
      }

      //只支持单根节点，也可以后端直接返回单个对象
      let deptArr = treeData || [];
      this.rootNode = deptArr[0]
      //根节点显示父名称
      this.rootNode.name = this.parentData.company_name;
    },

    //节点计算
    process(node, offset) {
      node.children = node.children || []
      let children = node.children;
      node.rect_width = this.config.cellWidth
      if (node.level === 0) {
        node.rect_width = this.config.cellWidthRoot
      }
      node.offset = offset || 0

      if (children.length > 0) {
        let cnt = 0;
        let offset = node.offset || 0

        for (let n of children) {
          this.process(n, offset);
          cnt += n.leaf_cnt

          offset += n.leaf_cnt

          this.lineList.push({fromId: node.id, toId: n.id})
        }
        node.leaf_cnt = cnt
      } else {
        node.leaf_cnt = 1
      }

      if (children.length > 0) {
        node.x = (children[0].x + children[children.length - 1].x) / 2
      } else {
        node.x = (this.config.cellWidth + this.config.cellGap) * (node.offset + node.leaf_cnt / 2) - (this.config.cellWidth + this.config.cellGap) / 2
      }
      if (children.length == 0) {
        node.x = node.x + (this.config.cellWidthRoot - this.config.cellWidth - 150) / 2
      }
      if (node.level == 0) {
        node.x = node.x - (this.config.cellWidthRoot - this.config.cellWidth) / 2
      }

      node.y = node.level * this.config.levelHeight + 1

      this.nodeList.push(node)
      if (node.level == 0 && node.x < 1) {
        let diff = 1 - node.x
        this.nodeList.forEach(item => item.x += diff)
      }
    },

    //节点上显示数据条数
    async getNodeBadgeCnt() {
      this.cntList = [];
      console.log("getNodeBadgeCnt start...")
      for (let nodeData of this.nodeList) {
        let params = {company_id: this.parentData.company_id, department_id: nodeData.id}
        let cntData = await this.$http('companyOrganizationService.getSysChartCnt', params);
        this.cntList.push(cntData);
      }

      this.searchByScene();
    },

    //绘制流程图
    drawImage() {
      console.log("drawImage start...");
      // 创建画布
      var graph = new mxGraph(this.$refs.graph_container);
      this.graph = graph;
      graph.setEnabled(false); //设置启用,就是允不允许你改变CELL的形状内容。
      graph.setVertexLabelsMovable(false);
      graph.centerZoom = false;

      var style = graph.getStylesheet().getDefaultEdgeStyle();
      // style[mxConstants.STYLE_EDGE] = mxEdgeStyle.ElbowConnector; //自己拐弯的连线
      style[mxConstants.STYLE_EDGE] = mxEdgeStyle.TopToBottom; //从上到下的连线
      style[mxConstants.STYLE_FONTSIZE] = 16; //文字大小
      style[mxConstants.STYLE_FONTCOLOR] = "ff00ff";
      style[mxConstants.STYLE_WHITE_SPACE] = "wrap";//自动换行
      graph.getView().updateStyle = true; // 动态改变样式
      graph.setHtmlLabels(true);

      mxConstants.WORD_WRAP = "break-word";

      var parent = graph.getDefaultParent();
      //开始更新画布
      graph.getModel().beginUpdate();


      var that = this;
      //添加点击事件
      graph.addListener(mxEvent.CLICK, function (sender, evt) {
        console.log('click in ...');
        // var e = evt.getProperty('event'); // mouse event
        var cell = evt.getProperty('cell'); // cell may be null
        if (cell != null) {
          var id = cell.id;
          that.currentNodeId = id;
          that.currentNodeName = cell.name
          console.log('that.currentNodeId666=' + that.currentNodeId);

          Object.values(graph.getModel().cells).filter(cell => cell.vertex).forEach(cell => {
            graph.getModel().setStyle(cell, that.getNodeStyle(cell))
          })
          that.searchByScene();

          evt.consume();
        }
      });

      try {

        // 插入节点
        var nodeObjects = {}
        for (var i = 0; i < this.nodeList.length; i++) {
          var nodeData = this.nodeList[i];
          var id = nodeData.id;
          var nodeStyle = this.getNodeStyle(nodeData);
          if (this.cntList[i]?.department_id == nodeData.id) {
            var cnt = this.cntList[i]?.cnt;
          }
          var name = '';
          if (!nodeData.leader_name) {
            if (nodeData.model_id === "company_organization_template") {
              name = nodeData.name
            } else {
              name = nodeData.name + "<br/>" + "  (" + cnt + "/" + nodeData.number + ")"
            }
          } else {
            name = nodeData.name + "<br/>" + nodeData.leader_name + "  (" + cnt + "/" + nodeData.number + ")"
          }

          var cell = graph.insertVertex(parent, null, name, nodeData.x, nodeData.y, nodeData.rect_width, this.config.cellHeight, nodeStyle);
          cell.id = id
          cell.name = nodeData.name;
          cell.leader_name = nodeData.leader_name;
          cell.number = nodeData.number;
          cell.parent_id = nodeData.parent_id;
          nodeObjects[id] = cell;
        }

        //插入线条
        for (let line of this.lineList) {
          if (nodeObjects[line.fromId] && nodeObjects[line.toId]) {
            graph.insertEdge(parent, null, null, nodeObjects[line.fromId], nodeObjects[line.toId]);
          }
        }

      } finally {
        // 画布更新结束
        graph.getModel().endUpdate();
      }
    },
    clearImage() {
      console.log("clearImage start.... -=")
      //var graph = this.graph;
      //开始更新画布
      //graph.getModel().beginUpdate();
      //graph.removeCells(graph.getChildVertices(graph.getDefaultParent())); //清空画布
      //graph.getModel().endUpdate();

      document.getElementById(this.containerId).innerHTML = "";
    },

    //节点上显示数据条数样式
    getEdgesNodeStyle() {
      var edgesStyle = 'fontSize=13;fontColor=white;rounded=1;perimeter=ellipsePerimeter;arcSize=50;fillColor=red ';
      return edgesStyle;
    },

    //节点样式
    getNodeStyle(nodeData) {
      var style = 'whiteSpace=wrap;fontSize=15;word-break=break-all;rounded=1;perimeter=ellipsePerimeter;arcSize=30';

      if (this.currentNodeId == nodeData.id) {
        style = style + ';strokeColor=orange;strokeWidth=3';
      }
      return style;
    },
    zoomIn() {
      this.graph.zoomIn()
    },
    zoomOut() {
      this.graph.zoomOut()
    }

  }
}
</script>


<style lang="less" scoped>

.splitpanes__pane {
  background-color: white !important;
}

.splitpanes__splitter {
  background-color: whitesmoke !important;
  width: 2px;
}

.graph_container {
  background-color: white;
}

.form_switch_toolbar {
  display: inline-flex;
  padding: 5px;
}

.form_switch_button {
  display: inline-block;
  margin-right: -2px;
}

.form_switch_button_active {
  display: inline-block;
  margin-right: -2px;
  border-color: #0a84ff;
}

.form_title {
  background-color: whitesmoke;
  border: 1px solid #e5e5e5;
  width: 100%;
  height: 38px;
  line-height: 38px;
  font-size: 18px;
  white-space: pre-wrap;
  padding-left: 10px;
  margin-top: -1px;
  display: inline-flex;
  word-break: break-all;
  word-wrap: break-word;
}

.box {
  //height: 630px;
  height: 743px;
  //height: 100%;
  display: flex;
  flex-direction: column;
}

.box-row {
  flex: 1;
  overflow: auto;
  padding-bottom: 10px;
  position: relative;
}

.box-row::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

.box-row::-webkit-scrollbar-thumb {
  border-radius: 5px;
  -webkit-box-shadow: inset 0 0 5px silver;
  background: silver;
}

.box-row::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px linen;
  border-radius: 0px;
  background: #dddddd;
}

.border {
  font-size: 36px;
  text-align: center;
  margin-top: 40px;
  border: 1px solid lightgrey;
  padding: 80px
}

.control {
  font-size: 22px;
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 10px;
  left: 10px;
  cursor: pointer;
}

</style>
